module.exports = "<employee-statistic></employee-statistic>";